import { LazyMotion } from 'framer-motion';
import React from 'react';

const loadFeatures = () =>
  import('./motion-features').then((res) => res.default);

export default function LazyMotionProvider({
 children,
}: {
  children: React.ReactNode;
}) {
  return <LazyMotion features={loadFeatures}>{children}</LazyMotion>;
}
